import { Menu, MenuButton, MenuItems, Transition } from '@headlessui/react';

import EllipsisVerticalIcon from '@heroicons/react/20/solid/EllipsisVerticalIcon';
import { DROPDOWN_TRANSITION } from '../constants';
import classNames from 'classnames';
import { BUTTON_ANIMATION, getButtonColorClasses } from '../../buttons/constants';
import { ButtonType } from '../../buttons/ButtonType';
import { DropdownOption } from '../DropdownOption';
import { useTheme } from '../../../../context/theme/useTheme';
import { IconType } from '../../../../constants';
import { ThemePopup } from '../../../../context/theme/ThemeConstantsUpdated';
import { m } from 'framer-motion';

const { background, secondaryText } = ThemePopup;

export const OptionsDropdown = (props: DropdownProps) => {
  const { options, buttonClassName, className, isAlert, buttonType, onDropdownClose, includeAnimation } = props;
  const { isDarkMode } = useTheme();
  const Icon = props.Icon || EllipsisVerticalIcon;

  return (
    <Menu as="div" className={classNames(className, 'relative flex justify-center align-middle')}>
      <MenuButton className="flex items-center rounded-full">
        <m.div
          {...(includeAnimation ? BUTTON_ANIMATION : {})}
          className={classNames(
            buttonClassName,
            getButtonColorClasses({
              buttonType: buttonType ?? (isAlert ? ButtonType.Alert : ButtonType.Link),
              isDarkMode,
            }),
            'rounded-full p-1.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2'
          )}
        >
          <Icon className="h-6 w-6" />
        </m.div>
      </MenuButton>
      <Transition {...DROPDOWN_TRANSITION} afterLeave={() => onDropdownClose && onDropdownClose()}>
        <div className="z-1 absolute right-0 top-9 mt-2 origin-top-right">
          {options && (
            <MenuItems
              as="div"
              className={classNames(background, secondaryText, 'mt-2 w-56 rounded-md text-left focus:outline-none')}
            >
              {options?.map((o, i) => (
                <DropdownOption key={o.label} onClick={o.onClick} isFirst={i === 0} isLast={i === options.length - 1}>
                  <span className="whitespace-nowrap text-left text-sm">{o.label}</span>
                </DropdownOption>
              ))}
            </MenuItems>
          )}
        </div>
      </Transition>
    </Menu>
  );
};

export type DropdownOption = {
  label: string;
  onClick: () => void;
};

export type DropdownProps = {
  options?: Array<DropdownOption>;
  buttonClassName?: string;
  className?: string;
  isAlert?: boolean;
  Icon?: IconType;
  buttonType?: ButtonType;
  includeAnimation?: boolean;
  onDropdownClose?: () => void;
};
